import './player-list.scss';

import { type CSSProperties, memo, type ReactNode } from 'react';

import { PlayerAvatar } from '@/shared/ui/PlayerAvatar';

export interface PlayerListItem {
  id: string;
  username: string;
  avatar?: string | null;
  amount: ReactNode;
  extra?: ReactNode;
  status?: 'default' | 'won' | 'lost';
}

export interface PlayerListProps {
  title: string;
  count: number;
  items: PlayerListItem[];
}

function PlayerListComponent({ title, count, items }: PlayerListProps) {
  if (items.length === 0) return null;

  return (
    <div className="player-list">
      <h4 className="player-list__title">
        {title} <span className="player-list__count">{count}</span>
      </h4>
      <div className="player-list__items">
        {items.map((item, i) => (
          <div
            key={item.id}
            style={{ '--row-in-delay': `${i * 0.04}s` } as CSSProperties}
            className={`player-list__row${item.status === 'won' ? ' player-list__row--won' : ''}${item.status === 'lost' ? ' player-list__row--lost' : ''}`}>
            <PlayerAvatar id={item.id} avatar={item.avatar} size={22} />
            <span className="player-list__name">@{item.username}</span>
            <div className="player-list__right">
              <span className="player-list__amount">{item.amount}</span>
              {item.extra}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export const PlayerList = memo(PlayerListComponent);
